var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSchoolHat = function SvgSchoolHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    className: "icon",
    viewBox: "0 0 1088 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M804.855 462.08v361.088C726.967 870.848 633.847 896 535.095 896c-98.752 0-191.872-25.152-269.76-72.832V452.992l-64-30.72v405.312c0 18.56 8.96 36.48 24.704 46.528C311.159 927.744 418.295 960 535.159 960c116.736 0 223.872-32.256 308.992-85.888a54.912 54.912 0 0 0 24.704-46.528V431.168l-64 30.976z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M535.095 64a181.12 181.12 0 0 0-77.632 17.536L28.855 285.888a50.56 50.56 0 0 0 0 91.328l428.608 204.352a180.224 180.224 0 0 0 155.264 0l428.608-204.352a50.56 50.56 0 0 0 0-91.328L612.727 81.536A180.928 180.928 0 0 0 535.095 64m0 64c17.28 0 34.56 3.968 50.112 11.328l403.2 192.256-403.2 192.256a117.76 117.76 0 0 1-100.224 0l-403.2-192.256 403.2-192.256c15.552-7.36 32.896-11.328 50.112-11.328"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M920.439 609.152h64v-240h-64z"
  })));
};
export default SvgSchoolHat;